class HzCountdown extends HTMLElement {
  #interval;

  connectedCallback() {
    if (!this.#update()) return;
    this.#interval = window.setInterval(() => this.#update(), 1000);
  }

  disconnectedCallback() {
    if (this.#interval) window.clearInterval(this.#interval);
    this.#interval = undefined;
  }

  #update() {
    const endAtValue = (this.dataset.endAt || '').trim();
    const endAt = Date.parse(endAtValue);
    const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/i.test(endAtValue);
    if (Number.isNaN(endAt) || !hasTimezone) {
      const timer = this.querySelector('[data-countdown-timer]');
      const fallback = this.querySelector('[data-countdown-fallback]');
      if (timer) timer.hidden = true;
      if (fallback) fallback.hidden = false;
      return false;
    }

    const remaining = endAt - Date.now();
    const timer = this.querySelector('[data-countdown-timer]');
    const fallback = this.querySelector('[data-countdown-fallback]');
    const expired = this.querySelector('[data-countdown-expired]');

    if (remaining <= 0) {
      if (timer) timer.hidden = true;
      if (fallback) fallback.hidden = true;
      if (expired) {
        expired.textContent = this.dataset.expiredMessage || '';
        expired.hidden = false;
      }
      if (this.#interval) window.clearInterval(this.#interval);
      this.#interval = undefined;
      return false;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.#setValue('days', days);
    this.#setValue('hours', hours);
    this.#setValue('minutes', minutes);
    this.#setValue('seconds', seconds);
    if (timer) timer.hidden = false;
    if (fallback) fallback.hidden = true;
    if (expired) expired.hidden = true;
    return true;
  }

  #setValue(unit, value) {
    const element = this.querySelector(`[data-countdown-value="${unit}"]`);
    if (element) element.textContent = String(value).padStart(2, '0');
  }
}

if (!customElements.get('hz-countdown')) {
  customElements.define('hz-countdown', HzCountdown);
}
